import { render, staticRenderFns } from "./region-select.vue?vue&type=template&id=8576965a&scoped=true&"
import script from "./region-select.vue?vue&type=script&lang=js&"
export * from "./region-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8576965a",
  null
  
)

export default component.exports